"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (hexStringWithHash) => {
    hexStringWithHash = hexStringWithHash.replace('#', '');
    if (hexStringWithHash.length !== 6) {
        throw 'Only six-digit hex colors are allowed.';
    }
    const aRgbHex = hexStringWithHash.match(/.{1,2}/g);
    return [
        parseInt(aRgbHex[0], 16),
        parseInt(aRgbHex[1], 16),
        parseInt(aRgbHex[2], 16)
    ];
};
